import { useState, FormEvent } from 'react';

export default function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5o8jffecauet1j8bcqg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        form.reset();
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="mb-12 sm:mb-16 text-center animate-fade-in-up">
          <span className="inline-block bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold px-5 py-2 rounded-full mb-4">
            ご相談はこちら
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-purple-900 tracking-tight mb-4 sm:mb-6">
            お問い合わせ
          </h2>
          <p className="text-base sm:text-lg font-medium text-purple-800 max-w-2xl mx-auto px-4">
            AIコンサルティング、ライティング、SNS支援など、<br className="hidden sm:block" />
            お気軽にご相談ください。
          </p>
        </div>

        <div className="max-w-3xl mx-auto animate-fade-in-up" style={{ animationDelay: '200ms' }}>
          <div className="bg-white rounded-lg p-6 sm:p-10 lg:p-12 shadow-lg border border-purple-100">
            <form 
              id="contact-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-6"
            >
              <div>
                <label htmlFor="name" className="block text-base font-semibold text-purple-900 mb-2">
                  お名前 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-purple-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-base"
                  placeholder="山田太郎"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-base font-semibold text-purple-900 mb-2">
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-purple-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-base"
                  placeholder="example@email.com"
                />
              </div>

              <div>
                <label htmlFor="service" className="block text-base font-semibold text-purple-900 mb-2">
                  ご希望のサービス
                </label>
                <select
                  id="service"
                  name="service"
                  className="w-full px-4 py-3 border border-purple-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-base bg-white"
                >
                  <option value="">選択してください</option>
                  <option value="相談する">相談する</option>
                  <option value="AIコンサルティング">AIコンサルティング</option>
                  <option value="AIライティング">AIライティング</option>
                  <option value="SNS・コンテンツ支援">SNS・コンテンツ支援</option>
                  <option value="その他">その他</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-base font-semibold text-purple-900 mb-2">
                  お問い合わせ内容 <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={6}
                  className="w-full px-4 py-3 border border-purple-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-base resize-none"
                  placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                />
              </div>

              {submitStatus === 'success' && (
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-800 text-base font-medium">
                  お問い合わせありがとうございます。内容を確認次第、ご連絡させていただきます。
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-base font-medium">
                  送信に失敗しました。もう一度お試しください。
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white py-4 px-8 rounded-lg font-semibold text-base hover:from-purple-600 hover:to-pink-600 transition-all duration-300 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? '送信中...' : '送信する'}
              </button>
            </form>

            <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-purple-100 flex justify-center">
              <img 
                src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/e0a38c2585532f9a804a48c9264dc408.png" 
                alt="KIMURAMA WORKS" 
                className="h-6 sm:h-7 opacity-30"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}